import React, { useState } from "react";
import * as XLSX from "xlsx";
import { ArrowLeft, UploadCloud } from "lucide-react";

const BulkUpload = () => {
  const [excelData, setExcelData] = useState([]);
  const [fileName, setFileName] = useState("");
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = event.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

      setExcelData(sheetData);
    };
    reader.readAsBinaryString(file);
  };
  const handleBulkSubmit = async () => {
    if (excelData.length === 0) {
      alert("Please upload a file first!");
      return;
    }

    try {
      const response = await fetch("https://localhost:44302/api/ElevatorProducts/bulkcreate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(excelData),
      });

      if (response.ok) {
        alert("Bulk Upload Successful!");
        setExcelData([]);
        setFileName("");
      } else {
        alert("Failed to upload!");
      }
    } catch (error) {
      console.error(error);
      alert("Error occurred!");
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <ArrowLeft onClick={() => (window.location.href = "/add-product")} className="cursor-pointer" />
        <h1 className="text-2xl font-semibold">Bulk Products</h1>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200">
        <div className="flex flex-col items-center justify-center border-2 border-dashed p-10 rounded-lg">
          <UploadCloud className="text-blue-600" size={60} />

          <p className="text-gray-600 mt-2">
            Upload <b>Excel (.xlsx)</b> or <b>CSV (.csv)</b> file
          </p>

          <input
            type="file"
            accept=".xlsx, .xls, .csv"
            onChange={handleFileUpload}
            className="mt-4"
          />

          {fileName && (
            <p className="mt-3 text-green-700 font-medium">Selected File: {fileName}</p>
          )}
        </div>
        {excelData.length > 0 && (
          <div className="mt-8">
            <h2 className="text-xl font-semibold mb-4">Preview Data</h2>

            <div className="overflow-auto border rounded-lg" style={{ maxHeight: "400px" }}>
              <table className="min-w-full text-sm">
                <thead className="bg-gray-200 sticky top-0">
                  <tr>
                    {Object.keys(excelData[0]).map((col, index) => (
                      <th key={index} className="px-3 py-2 border text-left font-medium">
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {excelData.map((row, rowIndex) => (
                    <tr key={rowIndex} className="odd:bg-white even:bg-gray-50">
                      {Object.keys(row).map((col, colIndex) => (
                        <td key={colIndex} className="px-3 py-2 border">
                          {row[col]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button
              onClick={handleBulkSubmit}
              className="bg-green-600 text-white px-6 py-3 rounded-lg mt-6 hover:bg-green-700 transition shadow"
            >
              Upload All Products ✔
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkUpload;
